module.exports = __webpack_public_path__ + "static/app-pitch-1-f181b217a912d447dcca552e8e3a9fbc.webp";